import i18n, { type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import { applyDocumentProductBrand } from "../branding/productBrand";
import {
  DEFAULT_SUPPORTED_LOCALE,
  SUPPORTED_LOCALES,
  normalizeSupportedLocale,
  type SupportedLocale,
} from "../profile/profileApi";
import { enLocale } from "./locales/en";
import { ruLocale } from "./locales/ru";

export const DEFAULT_WEB_LOCALE: SupportedLocale = DEFAULT_SUPPORTED_LOCALE;
export const FALLBACK_WEB_LOCALE: SupportedLocale = DEFAULT_SUPPORTED_LOCALE;
export const WEB_SUPPORTED_LOCALES: readonly SupportedLocale[] = SUPPORTED_LOCALES;

export const WEB_I18N_RESOURCES = {
  en: {
    translation: enLocale,
  },
  ru: {
    translation: ruLocale,
  },
} as const;

let initialized = false;

export function initializeI18n(instance: I18nInstance = i18n): I18nInstance {
  if (initialized || instance.isInitialized) {
    applyDocumentProductBrand(instance.resolvedLanguage ?? instance.language ?? DEFAULT_WEB_LOCALE);
    return instance;
  }

  void instance.use(initReactI18next).init({
    resources: WEB_I18N_RESOURCES,
    lng: DEFAULT_WEB_LOCALE,
    fallbackLng: FALLBACK_WEB_LOCALE,
    supportedLngs: WEB_SUPPORTED_LOCALES,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

  applyDocumentProductBrand(DEFAULT_WEB_LOCALE);
  initialized = true;
  return instance;
}

export const runtimeI18n = initializeI18n();

export async function applyRuntimeLocale(
  locale: unknown,
  instance: I18nInstance = runtimeI18n,
): Promise<void> {
  const normalized = normalizeSupportedLocale(locale);
  if (instance.resolvedLanguage !== normalized) {
    await instance.changeLanguage(normalized);
  }
  applyDocumentProductBrand(normalized);
}
